module.exports = __webpack_public_path__ + "assets/img/20_993.8db39ff6.jpg";